<template>
  <header class="sticky touch-manipulation select-none top-0 z-50 w-full h-16 shrink-0 bg-white shadow justify-start items-center inline-flex">
    <button @click="toggleSidebar" class="flex w-16 self-stretch justify-center items-center">
      <img width="24" height="24" src="@/assets/hamburger-icon.svg" />
    </button>

    <div @click="goto('/')"
      class="grow shrink basis-0 self-stretch flex-col justify-center items-center gap-2.5 inline-flex">
      <img width="52" height="26" src="@/assets/qstar-logo.svg" />
    </div>

    <button @click="goto('/info')" class="flex w-16 self-stretch px-4 justify-start items-center">
      <div class="w-8 h-8 relative bg-gray-100 rounded-2xl">
        <img width="32" height="32" src="@/assets/profile-picture-placeholder.svg" />
      </div>
    </button>
  </header>

  <div class="relative z-50 select-none touch-manipulation" role="dialog" aria-modal="true">
    <Transition enter-active-class="ease-in-out duration-500" leave-active-class="ease-in-out duration-500"
      enter-class="opacity-0" enter-to-class="opacity-100" leave-class="opacity-100" leave-to-class="opacity-0">
      <div v-show="isOpen" class="fixed inset-0 bg-gray-900/80 transition-opacity">
      </div>
    </Transition>

    <div v-show="isOpen" class="fixed inset-0 flex select-none">
      <div class="relative mr-16 flex w-full max-w-xs flex-1">
        <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
          <button @click="toggleSidebar" type="button" class="-m-2.5 p-2.5">
            <span class="sr-only">Close sidebar</span>
            <svg class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
              aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <Transition enter-active-class="ease-in-out duration-500" leave-active-class="ease-in-out duration-500"
          enter-class="-translate-x-full" enter-to-class="translate-x-0" leave-class="translate-x-0"
          leave-to-class="-translate-x-full">
          <div v-show="isOpen"
            class="flex grow flex-col gap-y-0 overflow-y-auto bg-gray-50 px-6 pb-4 transform">
            <div class="flex h-16 shrink-0 items-center">
              <img width="52" height="26" src="@/assets/qstar-logo.svg" alt="qstar-logo" />
            </div>
            <nav class="flex flex-1 flex-col">
              <ul role="list" class="flex flex-1 flex-col gap-y-7">
                <li>
                  <ul role="list" class="-mx-2 space-y-1">
                    <li>
                      <!-- Current: "bg-gray-200 text-primary", Default: "text-secondary hover:bg-gray-200" -->
                      <a @click="goto('/reports')"
                        class="bg-gray-200 text-primary group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer">
                        <div class="h-6 w-6 shrink-0">
                          <svg class="h-6 w-6 shrink-0 fill-primary" viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_10_4440)">
                              <path
                                d="M18.5 12C18.5 13.7239 17.8152 15.3772 16.5962 16.5962C15.3772 17.8152 13.7239 18.5 12 18.5C10.2761 18.5 8.62279 17.8152 7.40381 16.5962C6.18482 15.3772 5.5 13.7239 5.5 12C5.5 10.2761 6.18482 8.62279 7.40381 7.40381C8.62279 6.18482 10.2761 5.5 12 5.5C13.7239 5.5 15.3772 6.18482 16.5962 7.40381C17.8152 8.62279 18.5 10.2761 18.5 12ZM4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12ZM11.25 7.75V12C11.25 12.25 11.375 12.4844 11.5844 12.625L14.5844 14.625C14.9281 14.8562 15.3938 14.7625 15.625 14.4156C15.8562 14.0687 15.7625 13.6062 15.4156 13.375L12.75 11.6V7.75C12.75 7.33437 12.4156 7 12 7C11.5844 7 11.25 7.33437 11.25 7.75Z" />
                            </g>
                          </svg>
                        </div>
                        Indberetninger
                      </a>
                    </li>
                    <li>
                      <a @click="goto('/reports/week/time')"
                        class="text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer">
                        <div class="h-6 w-6 shrink-0"></div>
                        Timesedler
                      </a>
                    </li>
                    <li>
                      <a @click="goto('/reports/week/transport')"
                        class="text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer">
                        <div class="h-6 w-6 shrink-0"></div>
                        Transport
                      </a>
                    </li>
                    <!-- <li>
                      <a @click="goto('/reports/create/diet')"
                        class="text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer">
                        <div class="h-6 w-6 shrink-0"></div>
                        Diæter
                      </a>
                    </li> -->
                    <li>
                      <a @click="goto('/reports/week/sick')"
                        class="text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer">
                        <div class="h-6 w-6 shrink-0"></div>
                        Sygdom
                      </a>
                    </li>
                    <li>
                      <a @click="goto('/mobilization/plan')"
                        class="text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer">
                        <div class="h-6 w-6 shrink-0">
                          <svg class="h-6 w-6 shrink-0 fill-primary" viewBox="0 0 24 25" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_10_4447)">
                              <path
                                d="M9.42857 4C9.42857 3.525 9.04643 3.14285 8.57143 3.14285C8.09643 3.14285 7.71429 3.525 7.71429 4V5.42857H6.28571C5.025 5.42857 4 6.45357 4 7.71428V8.28571V10V19.1429C4 20.4036 5.025 21.4286 6.28571 21.4286H17.7143C18.975 21.4286 20 20.4036 20 19.1429V10V8.28571V7.71428C20 6.45357 18.975 5.42857 17.7143 5.42857H16.2857V4C16.2857 3.525 15.9036 3.14285 15.4286 3.14285C14.9536 3.14285 14.5714 3.525 14.5714 4V5.42857H9.42857V4ZM5.71429 10H18.2857V19.1429C18.2857 19.4571 18.0286 19.7143 17.7143 19.7143H6.28571C5.97143 19.7143 5.71429 19.4571 5.71429 19.1429V10Z" />
                            </g>
                          </svg>
                        </div>
                        Min plan / Mobiliseringer
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="mt-auto">
                  <a href="#/login" class="text-secondary hover:bg-gray-200 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold cursor-pointer" v-on:click="signOut()">
                    <div class="h-6 w-6 shrink-0">
                      <svg class="h-6 w-6 shrink-0 fill-primary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                          d="M96 64h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h84c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H96c-53 0-96-43-96-96V160c0-53 43-96 96-96zm231.1 19.5l-19.6 19.6c-4.8 4.8-4.7 12.5 .2 17.1L420.8 230H172c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h248.8L307.7 391.7c-4.8 4.7-4.9 12.4-.2 17.1l19.6 19.6c4.7 4.7 12.3 4.7 17 0l164.4-164c4.7-4.7 4.7-12.3 0-17l-164.4-164c-4.7-4.6-12.3-4.6-17 .1z" />
                      </svg>
                    </div>
                    Log ud
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { mapActions, mapState, useStore } from 'vuex'
import applicationUserManager from '@/core/applicationusermanager'

export default defineComponent({
  name: 'AppMenu',
  setup () {
    const store = useStore()
    const router = useRouter()

    const isOpen = computed(() => store.state.menu.isOpen)

    const toggleSidebar = () => {
      store.dispatch('menu/toggleMenu')
      // nextTick(() => {
      // })
    }

    const goto = (path: string) => {
      if (isOpen.value) {
        store.dispatch('menu/toggleMenu')
      }
      router.push(path)
    }

    const signOut = () => {
      applicationUserManager.logout()
      store.dispatch('menu/toggleMenu')
    }

    return {
      isOpen,
      toggleSidebar,
      goto,
      signOut
    }
  },
  methods: {}
})
</script>
